import { useMutation, useQueryClient } from 'react-query';

import { changesSaved, genericError } from 'store/Layout';
import { cacheKeys } from 'config';
import { documentsClient } from 'clients/documents/documentsClient';

export const useQuestionCrud = () => {
  const queryClient = useQueryClient();

  const createQuestion = useMutation(documentsClient.createQuestion, {
    mutationKey: cacheKeys.documents.createQuestion,
    onSuccess: (result, request) => {
      queryClient.invalidateQueries(cacheKeys.documents.getDocument);
      queryClient.invalidateQueries(cacheKeys.documents.getDraftDocument);
      queryClient.invalidateQueries(cacheKeys.documents.searchQuestions);
      changesSaved({});
    },
    onError: (result, request) => {
      genericError({});
    },
  });

  const patchQuestion = useMutation(documentsClient.patchQuestion, {
    mutationKey: cacheKeys.documents.patchQuestion,
    onSuccess: (result, request) => {
      queryClient.invalidateQueries(cacheKeys.documents.getDocument);
      queryClient.invalidateQueries(cacheKeys.documents.getDraftDocument);
      queryClient.invalidateQueries(cacheKeys.documents.searchQuestions);
      changesSaved({});
    },
    onError: (result, request) => {
      genericError({});
    },
  });

  const deleteQuestion = useMutation(documentsClient.deleteQuestion, {
    mutationKey: cacheKeys.documents.deleteQuestion,
    onSuccess: (result, request) => {
      queryClient.invalidateQueries(cacheKeys.documents.getDocument);
      queryClient.invalidateQueries(cacheKeys.documents.getDraftDocument);
      queryClient.invalidateQueries(cacheKeys.documents.searchQuestions);

      changesSaved({});
    },
    onError: (result, request) => {
      genericError({});
    },
  });

  return {
    createQuestion,
    patchQuestion,
    deleteQuestion,
  };
};
